<template>
  <el-container>
    
    <el-header style="padding: 0; min-height: 30px;">
      <el-page-header @back="goBack()" :content="title">
      </el-page-header>
    </el-header>
    <el-main>
      <el-form ref="resourceForm" :model="form" :rules="rules" label-width="120px" class="demo-ruleForm t_center"
               align="left" label-position="left">
        <el-form-item label="上传教案:" prop="resourceUrl">
          <el-upload
                class="avatar-uploader el-upload--text"
                action="#"
                :show-file-list="true"
                :before-upload="beforeUploadVideo"
              >
                <div  v-if="form.resourceUrl !='' && videoFlag == false">{{form.resourceName}}</div>
                <div class="add-video" v-else-if="form.resourceUrl =='' && videoFlag == false">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
                <el-progress
                  v-if="videoFlag == true"
                  type="circle"
                  :percentage="videoUploadPercent"
                  style="margin-top:30px;"
                ></el-progress>
            </el-upload>
        </el-form-item>
        <el-form-item label="教案路径" prop="resourceUrl">
          <el-input v-model="form.resourceUrl" placeholder="教案路径" :disabled = "true"></el-input>
        </el-form-item>
        <el-form-item label="教案名称" prop="resourceName">
          <el-input v-model="form.resourceName" placeholder="教案名称"></el-input>
        </el-form-item>
        <el-form-item label="所属资源分类" prop="resourceCategoryId" class="cls-col">
          <!-- <el-select v-model="form.categoryData" placeholder="资源类别" size="small" @change="selectItem"> -->
          <el-select v-model="form.resourceCategoryId" placeholder="资源类别" size="small">
            <el-option
                v-for="item in categoryData"
                :key="item.id"
                :label="item.resourceCategoryName"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字" prop="keyWords">
          <el-input v-model="form.keyWords" placeholder="如有多个关键字，请用；隔开"></el-input>
        </el-form-item>
        <el-form-item align="center">
          <el-button @click="reset">重置</el-button>
          <el-button type="primary" @click="resourceSave">保存</el-button>
        
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import axios from 'axios'
  import {dateFormat} from '@/api/utils.js';
  import DndList from '@/components/DndList';
  import FileUpload from '@/components/FileUpload/FileUpload.vue';
import { type } from 'os';
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction
    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image'],
    ['clean']

  ];
  
  export default {
    components: {
      dateFormat,DndList, FileUpload
  },
    data() {
      return {
        loginOrgCode: '',
        resourceName: '添加资源',
        orgEdit: false,
        showThird: false,
        categoryData: [], //下拉菜单数据
        organizationData: [], //组织机构下拉
        attachmentList: [],//附件列表
        pictureFileList: [],
        dialogVisible: false,
        loaded: false,
        dialogImageUrl: '',
        reFresh: true,
        orgCode: '',
        categoryOptions: [],
        choseCommodityIds: [],
        choseCommodity: false,
        fileName:'',
        form: {
          keyWords:'',
          resourceUrl:'',
          resourceName: '',
          id: '',
          orgCode: '',
          resourceType:11,
          createTime: dateFormat(new Date()),
          rescourseId: '',
          auditionVideoPath: '',
          videoImageUrl: '',
          isShowimageUrl:false,
          imageUrl:'',
          resourceCategoryId:''
        },
        options: {
          img: '',                         //裁剪图片的地址
          info: true,                      //裁剪框的大小信息
          outputSize: 1,                   // 裁剪生成图片的质量
          outputType: 'jpeg',              //裁剪生成图片的格式
          canScale: false,                 // 图片是否允许滚轮缩放
          autoCrop: true,                  // 是否默认生成截图框
          fixed: false,                    //是否开启截图框宽高固定比例
          fixedNumber: [16, 9]              //截图框的宽高比例
        },
        videoFlag: false, //是否显示进度条
        videoUploadPercent: 0, //进度条的进度，
        duration: "", //教案时长
        rules: {
          resourceName: [
            {required: true, message: '请输入教案名称', trigger: 'blur'}
          ],
          // author: [
          //   {required: true, message: '请输入教案来源', trigger: 'blur'}
          // ],
          keyWords: [
            {required: true, message: '请输入关键字', trigger: 'blur'}
          ]
        },
        headers: {
          Authentication: localStorage.getItem('token')
        },
      };
    },
    methods: {
      exceed(res, file) {
        console.log(res);
      },

      onError () {
      },
      //上传教案格式限制
      beforeUploadVideo(file) {
        let pointIndex = file.name.lastIndexOf(".");
        let fileType = file.name.substring(pointIndex+1); //获取到文件后缀名
        // if (fileType !== 'mp3' && fileType !== 'ogg' && fileType !== 'wav') {
        if (fileType !== 'doc' && fileType !== 'pdf' && fileType !== 'xlsx' && fileType !== 'rar' && fileType !== 'docx' && fileType !== 'xlx' && fileType !== 'ppt' && fileType !== 'pptx' && fileType !== 'zip') {
          this.$message.error("请上传后缀名为pdf, doc, docx, xlx, xlsx, ppt, pptx, zip, rar等教案格式");
          return false
        }
        this.form.resourceName = file.name;
        this.addVideo(file);
        return false;
      },
      //上传教案接口
      addVideo(file) {
        this.form.resourceUrl='';
        //设置formData
        let formData = new FormData();
        formData.append("upfile", file);
        //在请求头设置上传进度条
        let config = {
          onUploadProgress: progressEvent => {
            var complete =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0;
            this.videoUploadPercent = complete;
          },
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };
        this.videoFlag = true;
        //调用后端上传教案的接口
        axios.post('/resources/updateResourceFile',formData, config).then(data => {
          this.videoFlag = false;
          if (data.data.code=="200") {
            this.form.resourceUrl=data.data.data.resourceUrl;          
          } else {
            this.$message.error('上传失败');
          }
        });
        return false;

      },  
      ajax(url,data,fn){
        const xhr =new XMLHttpRequest();
        xhr.onreadystatechange =function(){
          if(xhr.readyState ===4 && xhr.status ===200){
            fn(xhr.responseText);
          }
        }
        const formData=new FormData();
        formData.append('upfile',data);
        xhr.open("post",url,true);
        xhr.setRequestHeader("Authentication",localStorage.getItem("token"));
        xhr.send(formData);
      },

      selectItem(value){
        var aid =value;
         console.log(aid);
      },
      goBack() {
        this.$router.go(-1);
      },
      //保存资源数据
      resourceSave() {
        let params = this.form;
        this.$refs['resourceForm'].validate((valid) => {
          if (!valid) {
            this.$message.error('请正确填写信息！');
            return false;
          } else {
            let url = '/resources/addResourceInfo';
            if (this.form.id) {
              url = '/resources/updateResourceInfo';
            }
            https.fetchPost(url, params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.$router.push('/resources/resourcest');
              } else {
                this.$message({
                  type: 'info',
                  message: '操作失败：' + msg
                });
              }
            }).catch(err => {
                  this.$message.error('网络错误');
                }
            );
          }
        });
      },
      reset() {
        this.$refs['resourceForm'].resetFields();
        this.form.createTime = dateFormat(new Date(this.form.createTime));
      },
      loadRescourseCategory() {
        this.categoryData = [];
        let params = {
          // orgCode:this.form.orgCode
          orgCode:'blcuonline'
        };
        https.fetchPost('/resources/getCategoryList', params, 'json').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            if(data.data.data) {
              this.categoryData = data.data.data
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败'
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      changeOrg() {
        this.searchCourseType();
        this.loadRescourseCategory();
        this.form.id = "";
        this.form.ccId = "";
      },
    },
    created: function() {
      this.loginOrgCode = this.$store.state.orgCode;
      this.uploadURL = this.https.baseURL + '/resources/updateResourceFile';
      // this.loadRescourseCategory();
      this.loadRescourseCategory();
      this.form.isShowimageUrl=false;
      let dataForm = this.$route.params;
      if (dataForm.id) {
        this.title = '修改教案资源';
        this.orgEdit = true;
        dataForm.createTime = dateFormat(new Date(dataForm.createTime))
        this.form = dataForm;
        if(this.form.videoImageUrl){
          let pictureFile = {
              name: this.form.videoImageUrl,
              url: this.form.videoImageUrl
            };
            this.pictureFileList.push(pictureFile);
        }
      } else {
        this.title = '添加教案资源';
      }
    },
    
  };
</script>

<style>
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    width: 80%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  
  .el-col-11 {
    width: 30%;
    margin-right: 0px;
    padding-right: 0px;
  }
  
  .el-upload-list__item {
    width: 50%;
  }

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9 !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px !important;
  position: relative !important;
  overflow: hidden !important;
}
.avatar-uploader .el-upload:hover {
  border: 1px dashed #d9d9d9 !important;
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 300px;
  height: 178px;
  display: block;
}
.hide .el-upload--picture-card {
    display: none;
  }
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    width: 80%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  
  .el-col-11 {
    width: 30%;
    margin-right: 0px;
    padding-right: 0px;
  }
  
  .el-upload-list__item {
    width: 50%;
  }
</style>
